mutation verificationImageRotate($uuid: String, $image: String, $direction: String) {
    verificationImageRotate(uuid: $uuid, image: $image, direction: $direction)
}
